import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Product } from "../@types";

function useMerchantProducts(
  merchantId: string,
  options?: QueryObserverOptions<APIResponse<Product[]>, APIError>
) {
  const {
    data: products,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Product[]>, APIError>(
    "merchant-products-" + merchantId,
    () =>
      get(API_URL + `/commerce/merchants/${merchantId}/products`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    products,
    isError,
    error,
    isLoading,
  };
}

export default useMerchantProducts;
